module.exports = __webpack_public_path__ + "static/media/Cafe_Blank.c2e6fb7e.png";